export enum ColorPaletteFromImageEventType {
  PAGE_OPEN = 'page_open',
  FILE_UPLOAD = 'file_upload',
  TOGGLE_CLICK = 'toggle_click',
  PALETTE_EXPLORE = 'palette_explore',
  PALETTE_CLICK = 'palette_click',
  QR_CODE_CHOOSE = 'qr_code_choose',
  LINK_COPY = 'link_copy',
  FILE_DOWNLOAD = 'file_download',
  EXPORT_CLICK = 'export_click',
  UNOD_REDO_CLICK = 'undo_redo_click',
  START_OVER = 'start_over',
  DELETE_PALETTE = 'palette_delete',
  CIRCLE_DRAG = 'circle_drag',
  POPUP_OPEN = 'popup_open',
  POPUP_ACTION = 'popup_action',
  COLOR_ADD = 'color_add',
  PDF_SAVE = 'pdf_save',
}

export enum PageType {
  LANDING_PAGE = 'landing_page',
  EDITOR = 'editor',
}

export enum AppRoute {
  HOME = '/',
  EDITOR = '/editor',
}

export type FilesUploadParams = {
  page_name: string;
  position: number;
  upload_type: string;
  upload_version: string;
};

export type PopupActionParam = {
  action_type: string;
};

export type FileUploadParam = {
  file_format: string;
  upload_type: string;
  position: number;
  pageName: PageType;
};
